// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__36ojP","rootSuccess":"CompleteLink_rootSuccess__1dN_o","rootFailure":"CompleteLink_rootFailure__A66oL","isDisabled":"CompleteLink_isDisabled__9qFal"};